<template>
  <div id="app">
    <router-view />
    <Authenticate data-test-id="AuthenticateComponent" />
    <FeedbackModal data-test-id="FeedbackModalComponent" />
    <Version data-test-id="VersionComponent" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { LoggerService as lgg } from "vue-components-library";

import Authenticate from "@/App/components/Authenticate.vue";
import Version from "@/App/components/Version.vue";
import { FeedbackModal } from "@/App/components/feedback";

export default {
  name: "App",
  components: { Authenticate, Version, FeedbackModal },
  computed: {
    ...mapGetters("Login", {
      authToken: "authToken",
    }),
    ...mapGetters("Login", {
      user: "user",
    }),
    ...mapGetters("TeamSelection", {
      selectedTeam: "selectedTeam",
    }),
    ...mapGetters("PushNotification", ["registrationToken"]),
  },
  watch: {
    registrationToken: function () {
      if (this.user && this.user.id) {
        this.subscribePushNotification(`user-${this.user.id}`);
      }
    },
  },
  mounted() {
    const userLoggedIn = this.authToken && this.user && this.user.id;

    if (userLoggedIn) {
      lgg.addUserToDatadogContext(this.user);
      this.setupBroadcastMessagesAndSubscriptions({ uuid: this.user.id, hospitals: this.selectedTeam?.hospitals });
    }
    this.setupWindowFocus();
    this.validateToken();
    this.startAutoLogoutCheck();
  },
  methods: {
    ...mapActions("PubNubSubscription", [
      "subscribeBroadcastChannels",
      "loadBroadcastHistory",
      "subscribeHospitalsChannels",
      "setupBroadcastMessagesAndSubscriptions",
    ]),
    ...mapActions("Login", ["startAutoLogoutCheck", "validateToken"]),
    ...mapActions("PushNotification", {
      subscribePushNotification: "subscribe",
    }),
    setupWindowFocus() {
      // eslint-disable-next-line no-constant-condition
      if (/*@cc_on!@*/ false) {
        // check for Internet Explorer
        document.onfocusin = this.validateToken;
      } else {
        window.onfocus = this.validateToken;
      }
    },
  },
};
</script>

<style lang="scss">
body {
  background-color: #222;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #fff;
  background-color: #222;
  height: 100vh;
}
#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #fff;
  }
}
.version {
  position: absolute;
  bottom: 10px;
  right: 10px;
}
.ems-page {
  max-width: 600px;
  margin: auto;
}
.priority-1 {
  background-color: rgb(191, 19, 17) !important;
  color: #fff !important;
}
.priority-2 {
  background-color: rgb(231, 188, 1) !important;
  color: #fff !important;
}
.priority-3 {
  background-color: rgb(42, 161, 61) !important;
  color: #fff !important;
}
.modal {
  .modal-body.dark {
    background-color: #222;
    border: 3px solid #ccc;
    border-radius: 4px;
  }
  .minimize {
    color: #bf1311;
    cursor: pointer;
    background-color: #eee;
    padding: 4px 8px;
    border-radius: 4px;
    text-decoration: none;
  }
}

/* Customize website's scrollbar like Mac OS
Not supports in Firefox and IE */

/* total width */
.clean-scrollbar::-webkit-scrollbar {
  width: 6px;
}
/* scrollbar itself */
.clean-scrollbar::-webkit-scrollbar-thumb {
  background-color: #fff;
  border-radius: 16px;
}
/* set button(top and bottom of the scrollbar) */
.clean-scrollbar::-webkit-scrollbar-button {
  display: none;
}
.hidden {
  display: none;
}
</style>
